import React ,{useEffect} from 'react'
import InnerPageHero from '../components/sections/InnerPageHero'
import OurClients from '../components/sections/OurClients'
import GetInTouch from '../components/sections/GetInTouch'
import ServicesPage from '../components/sections/Services'
import { FaHome } from 'react-icons/fa';
import ServicesSingle from '../components/sections/ServicesSingle'

function Services() {
    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="app-container">
      <InnerPageHero
        title="Our Services"
        breadcrumbs={[
          { label: 'Home', href: '/', icon: FaHome },
          { label: 'Services', isCurrentPage: true }
        ]}
      />
      {/* <ServicesPage /> */}
      <ServicesSingle />
      {/* <OurClients /> */}
      <GetInTouch />
      {/* </main> */}
    </div>
  )
}

export default Services